import {HawkTestCreationModalComponent} from './+payrolls/hawk/hawk-test-creation-modal.component';
import {RetroChangesComponent} from './+payrolls/ongoing/retro-changes/retro-changes.component';
import {
  ManageEntityAccessCriterionModalComponent
} from './+settings/user-rights/manage-access-criterion-modal/manage-entity-access-criterion-modal/manage-entity-access-criterion-modal.component';
import {
  ManagePopulationAccessCriterionModalComponent
} from './+settings/user-rights/manage-access-criterion-modal/manage-population-access-criterion-modal/manage-population-access-criterion-modal.component';
import {
  TransferUserAccessModalComponent
} from './+settings/user-rights/transfer-user-access-modal/transfer-user-access-modal.component';
import {MyProfileComponent} from './me/my-profile.component';
import {
  GenerateDocumentModalComponent
} from './shared/generate-document/generate-document-modal/generate-document-modal.component';
import {ImageManagementComponent} from './shared/image-management/image-management.component';
import {Modals} from './shared/modal';
import {IdleTimeoutModalComponent} from './shared/modal/idle-timeout-modal/idle-timeout-modal.component';
import {CreatePopulationComponent} from './shared/population/create-population/create-population.component';
import {DeleteEntityModalComponent} from './shared/population/delete-entity-modal/delete-entity-modal.component';
import {SdcLogComponent} from './shared/sdconnect/sdc-log/sdc-log.component';
import {OrgEditModalComponent} from './shared/tree-diagram/org-edit-modal.component';
import {
  CreateAdminUserModalComponent
} from './shared/user/modal/create-admin-user-modal/create-admin-user-modal.component';
import {CreateUserModalComponent} from './shared/user/modal/create-user-modal/create-user-modal.component';
import {UserAvatarCropperComponent} from './shared/user/user-avatar-cropper.component';
import {
  ReassignRequestPopupComponent
} from './shared/workflow/reassign-request-popup/reassign-request-popup.component';
import {
  TemplateActionModalComponent
} from './template-management/template-action-modal/template-action-modal.component';
import {
  TemplateConditionsModalComponent
} from './template-management/template-editor/template-conditions-modal/template-conditions-modal.component';
import {
  AiGenerateModalComponent
} from '@gp/template-management/template-editor/ai-generate-modal/ai-generate-modal.component';

export const MODALS: Modals = [
  {component: MyProfileComponent, name: 'MyProfile'},
  {component: UserAvatarCropperComponent, name: 'UserAvatarCropper'},
  {component: ImageManagementComponent, name: 'ImageManagementComponent'},
  {component: OrgEditModalComponent, name: 'OrgEditModalComponent'},
  {component: CreateUserModalComponent, name: 'CreateUserModalComponent'},
  {component: CreateAdminUserModalComponent, name: 'CreateAdminUserModalComponent'},
  {component: CreatePopulationComponent, name: 'CreatePopulation'},
  {component: RetroChangesComponent, name: 'RetroChangesComponent'},
  {component: GenerateDocumentModalComponent, name: 'GenerateDocumentModalComponent'},
  {component: AiGenerateModalComponent, name: 'AiGenerateModalComponent'},
  {component: DeleteEntityModalComponent, name: 'DeleteEntityModalComponent'},
  {component: TemplateActionModalComponent, name: 'TemplateActionModalComponent'},
  {component: TransferUserAccessModalComponent, name: 'TransferUserAccessModalComponent'},
  {component: HawkTestCreationModalComponent, name: 'HawkTestCreationModalComponent'},
  {component: TemplateConditionsModalComponent, name: 'TemplateConditionsModalComponent'},
  {component: ManagePopulationAccessCriterionModalComponent, name: 'ManagePopulationAccessCriterionModalComponent'},
  {component: ManageEntityAccessCriterionModalComponent, name: 'ManageEntityAccessCriterionModalComponent'},
  {component: SdcLogComponent, name: 'SdcLogModalComponent'},
  {component: ReassignRequestPopupComponent, name: 'ReassignRequestPopupComponent'},
  {component: IdleTimeoutModalComponent, name: 'IdleTimeoutModalComponent'}
];
